var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.9724C24 5.36406 18.6083 0 12 0C5.39171 0 0 5.36406 0 11.9724C0 18.5806 5.39171 23.9723 12 23.9723C13.3548 23.9723 14.682 23.7512 15.9539 23.3088L21.4009 24.1382C21.4562 24.1382 21.4839 24.1382 21.5392 24.1382C21.7604 24.1382 22.0092 24.0276 22.1475 23.8617C22.341 23.6682 22.3963 23.3641 22.341 23.1152L21.4009 19.4101C22.1475 18.47 22.7281 17.447 23.1705 16.341C23.7235 14.9585 24 13.4931 24 11.9724ZM19.8525 18.6636C19.6866 18.8848 19.6313 19.1613 19.6866 19.3825L20.4055 22.2857L15.9816 21.6221C15.8433 21.5945 15.7051 21.6221 15.5668 21.6774C14.4055 22.1198 13.1889 22.3134 11.9724 22.3134C6.2765 22.3134 1.63134 17.6682 1.63134 11.9724C1.63134 6.2765 6.30415 1.65899 12 1.65899C17.6959 1.65899 22.341 6.30415 22.341 12C22.341 13.2995 22.0922 14.5714 21.6221 15.7604C21.2074 16.7834 20.6267 17.7788 19.8525 18.6636Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8ad4c2a63721c6f221420d8291c0b946.svg";
export { ForwardRef as ReactComponent };